import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Plan from './Plan';
import { getStatus } from '../../../../utils/dashboard/processCommon';
import Tooltip from '../../../common/tooltip/Tooltip';
import { processCommon } from '../../../../utils/dashboard/processCommon';

const EnrollmentPlans = (props) => {
    const {
        type,
        preDocVerificationShoppingEnabled,
        enrollments, 
        link,
        handleClick,
        showChangePlansLink,
        exceptionalCircumstanceCb
    } = props;

    const processedEnrollments = enrollments.map((enrollment, index) => {

        const {
            id: enrollmentId,
            plan: enrollmentPlan,
            enrollees,
            status: enrollmentStatus,
            coverageEndDate,
        } = enrollment;

        return (
            <div key={enrollmentId}
                className="grid-row padding-2"
                id={type + '_text'}
            >
                <div className="tablet:grid-col-5 padding-x-2">
                    <Plan plan={enrollmentPlan} />
                    <Tooltip
                        id='plans.for.member'
                        content={processCommon.getEnrolleesNames(enrollees)}
                        index={`enrollment_${enrollmentId}`}
                        replacement={{ numMember: enrollees.length }}
                        place='left'
                        contentClassName='gi-txt__capitalize'
                    />
                </div>

                <div className="tablet:grid-col-4 padding-x-2">
                    {
                        getStatus(
                            type,
                            enrollmentId,
                            enrollmentStatus,
                            { coverageEndDate },
                            preDocVerificationShoppingEnabled
                        )
                    }
                </div>

                { link &&
                <div className="tablet:grid-col-3 padding-x-2">
                    <a href="#" className="text-underline" onClick={handleClick}>
                        <FormattedMessage id={link}/>
                    </a>

                    { // Change Plan - Exceptional Circumstance link
                        index + 1 === enrollments.length && showChangePlansLink &&
                        <div className="margin-top-205">
                            <Tooltip
                                id='plans.change_plans_exceptional_circumstance'
                                content='plans.change_plans_exceptional_circumstance.hover'
                                index='change_plans_exceptional_circumstance'
                                contentClassName='gi-txt__capitalize'
                                triggerClassName='tooltip-link'
                                onClickHandler={exceptionalCircumstanceCb}
                            />
                        </div>
                    }

                </div>
                }
            </div>
        );
    });
    return (
        <Fragment>
            {processedEnrollments}
        </Fragment>);

};

export default EnrollmentPlans;